import {
  Flex,
  Card,
  Heading,
  Text,
  Label,
  TextAreaField,
  Button,
} from "@aws-amplify/ui-react";
import { useUserQuery } from "./useUserQuery";
import { useCareNoteByPredicateQuery } from "./api/useCareNotesQuery";
import { useState } from "react";
import { useCareNotePostMutation } from "./api/useCareNotesMutation";

export default function CareNotesCard({ noteSection, objectId }) {
  const [noteDetails, setNoteDetails] = useState("");
  const { data: userData } = useUserQuery();
  const {
    data: careNoteQueryData,
    isFetching,
    error,
  } = useCareNoteByPredicateQuery(
    userData?.patientUserId,
    (cn) => cn.noteSection === noteSection && cn.objectId === objectId
  );
  const { mutate: careNotePostMutate } = useCareNotePostMutation();

  const handleOnSubmit = (e) => {
    e.preventDefault();
    careNotePostMutate({
      patientUserId: userData?.patientUserId,
      objectId: objectId,
      noteDetails: noteDetails,
      noteSection: noteSection,
    });
    setNoteDetails("");
  };

  if (isFetching) return "Loading...";

  if (error) return "An error happened...";

  if (careNoteQueryData) {
    return (
      <Card variation="elevated">
        <Heading children="Notes" />
        {careNoteQueryData?.map((careNote) => {
          return (
            <Card variation="outlined" margin={12} key={`cnc_cnqd_${careNote?.id}`}>
              <Text
                variation="info"
                fontSize="0.85em"
                fontWeight={600}
                children={careNote?.updatedByName}
              />
              <Text
                variation="primary"
                fontSize="1em"
                children={careNote?.noteDetails}
              />
              <Text
                variation="primary"
                fontSize="0.85em"
                children={careNote?.createdAt}
              />
            </Card>
          );
        })}
        <Card>
          <Flex direction="column" justifyContent="flex-start">
            <form onSubmit={handleOnSubmit}>
              <Label>Add a new note:</Label>
              <TextAreaField
                placeholder="Note details..."
                required={true}
                value={noteDetails}
                onChange={(e) => setNoteDetails(e.target.value)}
              />
              <Button
                size="small"
                variation="primary"
                marginTop={9}
                type="submit"
                disabled={!noteDetails || noteDetails.trim() === ""}
              >
                Add Note
              </Button>
            </form>
          </Flex>
        </Card>
      </Card>
    );
  }
}
